import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import fetchAPI from '../../../common/fetchAPI'
import { getGoogleLoginRequestUri } from '../../../common/helpers'
import useToast from '../../../common/hooks/useToast'
import Spinner from '../../../components/common/Spinner'
import ErrorMessage from '../../../components/common/ErrorMessage'
import SectionContainer from '../../../components/common/SectionContainer'

export default function GoogleLoginCallback() {
    const [searchParams] = useSearchParams()
    const codeParam = searchParams.get('code')

    const [error, setError] = useState('')
    const navigate = useNavigate()
    const setToast = useToast()

    async function getGoogleClientId() {
        const { responseData, error } = await fetchAPI(
            `/v1/settings/google-client-id`,
        )
        const { googleClientId } = responseData
        if (error) {
            setToast(error, 'alert')
            return null
        }
        return googleClientId
    }

    useEffect(() => {
        postCode()

        async function postCode() {
            let googleClientId = await getGoogleClientId()
            if (!googleClientId) {
                setError('Failed to get Google Client ID')
                return
            }

            const { error } = await fetchAPI(
                `/v1/settings/google-code`,
                {
                    code: codeParam,
                    redirectUri: `${window.location.origin}/callbacks/google-login`,
                },
                'POST',
            )

            if (error) {
                setError(error)
                return
            }

            navigate('/settings')
            setToast('Google connected successfully')
        }
    }, [])

    if (error) {
        return (
            <SectionContainer>
                <ErrorMessage>{error}</ErrorMessage>
            </SectionContainer>
        )
    }

    return <Spinner />
}
